
import { Vue, Component, Prop } from "vue-property-decorator";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import Cookie from "js-cookie";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import {
  FormField,
  TextField,
  Preloader,
  FormSubmit,
  FormError
} from "../components";
import {
  SUBSCRIPTION_FORM_STEPS,
  emailValidator,
  subscriptionSubmit
} from "@/forms/service";

@Component({
  validations: {
    email: {
      required,
      maxLength: maxLength(255),
      minLength: minLength(4),
      noMatch: emailValidator
    }
  },
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    FormField,
    TextField,
    AmSpacing,
    AmButton,
    Preloader,
    FormSubmit,
    FormError
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: any;
  email = "";
  loading = false;
  errors = {};
  isError = false;

  onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }

    this.loading = true;
    this.isError = false;

    const formData = {
      email: this.email,
      pageTag: this.config.pageTag,
      language: this.config.language
    };

    subscriptionSubmit(formData)
      .then(({ data, next }) => {
        const smClientCookie = Cookie.get("Smclient");
        if (!smClientCookie || smClientCookie !== data.contactId) {
          Cookie.set("Smclient", data.contactId, { expires: 3650 });
        }

        if (next === SUBSCRIPTION_FORM_STEPS.THANK_YOU_STEP) {
          this.$emit("success");
        }
      })
      .catch(({ errors }) => {
        this.loading = false;

        if (errors) {
          this.errors = errors;
          return;
        }

        this.isError = true;
      });
  }
}
